const MembershipDatasetsModalCtrl = require('@/controllers/modal/MembershipDatasetsModalCtrl');

const ANGULAR_MODALS = {
    MEMBERSHIP_DATASETS: {
        className: 'membership-datasets',
        controller: MembershipDatasetsModalCtrl,
        template: 'partials/modals/membershipDatasetsModal.html',
    },
};

module.exports = {
    ANGULAR_MODALS,
};
